import axios from "axios";

const baseUrl = `${process.env.REACT_APP_GITO_API_URL}/tokens`;
//const baseUrl = "https://localhost:7241"

// Function to get all tokens
export async function getAllTokens(apiAccessToken) {
    try {
        const response = await axios.get(`${baseUrl}/token/get-all-tokens`, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${apiAccessToken}`,
            },
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.detail || 'Failed to fetch tokens');
    }
}

export async function getAllCustomerTokens(customerPublicId, apiAccessToken) {
    try {
        const response = await axios.get(`${baseUrl}/token/get-tokens/${customerPublicId}`, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${apiAccessToken}`,
            },
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.detail || 'Failed to fetch tokens');
    }
}



// Function to get token by ID
export async function getTokenByPublicId(publicId, apiAccessToken) {
    try {
        const response = await axios.get(`${baseUrl}/token/get-token/${publicId}`, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${apiAccessToken}`,
            },
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.detail || "Failed to fetch token");
    }
}

// Function to create token
export async function createToken(tokenData, apiAccessToken) {
    try {
        const response = await axios.post(`${baseUrl}/token/create-token`, tokenData, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${apiAccessToken}`,
            },
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.detail || "Failed to create token");
    }
}

// Function to update token
export async function updateToken(tokenData, apiAccessToken) {
    try {
        const response = await axios.put(`${baseUrl}/token/update-token`, tokenData, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${apiAccessToken}`,
            },
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.detail || "Failed to update token");
    }
}

// Function to delete token
export async function deleteToken(publicId, apiAccessToken) {
    try {
        await axios.delete(`${baseUrl}/token/delete-token/${publicId}`, {
            headers: {
                "Authorization": `Bearer ${apiAccessToken}`,
            },
        });
    } catch (error) {
        throw new Error(error.response?.data?.detail || "Failed to delete token");
    }
}

// Function to reset accumulated kWh on a token
export async function resetAccumulatedEnergy(publicId, apiAccessToken) {
    try {
        await axios.post(`${baseUrl}/token/reset-accumulated-energy/${publicId}`, null, {
            headers: {
                "Authorization": `Bearer ${apiAccessToken}`,
            },
        });
    } catch (error) {
        throw new Error(error.response?.data?.detail || "Failed to reset accumulated energy");
    }
}